export const ids = {
  errorMessage: 'errorMessage',
  bannerContainer: 'bannerContainer',
  arrivalOrderTypeButton: 'arrivalOrderTypeButton',
  departureOrderTypeButton: 'departureOrderTypeButton',
  pickupTimeInput: 'pickupTimeInput',
  rawFlightDateInput: 'rawFlightDateInput',
  menuTrigger: 'menuTrigger',
  userInfoBlock: 'userInfoBlock',
};
